export const FOLLOWABLE_TYPES = {
  BREEDER_BREED: 'BreederBreed',
  // Routing marker only — fans out into a BreederBreed follow for
  // each breed the breeder offers. No UserFollow row is stored
  // with this type.
  BREEDER_PROFILE: 'BreederProfile',
  BREED: 'Breed',
  DOG: 'Dog'
};

export const FOLLOWABLE_STATUS_MESSAGE = {
  ADDED_TO_FAVORITES: 'Added to',
  REMOVED_FROM_FAVORITES: 'Removed from'
};

export const FOLLOWABLE_STATUSES = {
  ADDED: 'added',
  REMOVED: 'removed'
};
